export const SET_SUMMARY = "SET_SUMMARY";
export const SET_IS_FETCHING_DATA = "SET_FETCHING_DATA";
export const SET_EVENTS = "SET_EVENTS";
export const SET_TODOS = "SET_TODOS";
export const SET_IS_FETCHING_TODO = "SET_IS_FETCHING_TODO";
export const SET_MATCHES = "SET_MATCHES";
export const SET_IS_FETCHING_MATCHES = "SET_IS_FETCHING_MATCHES";
